import axios from 'axios';

const API_URL = 'https://api-tools-clients-f0f98390c3dd.herokuapp.com/';
// const API_URL = 'http://localhost:3001/';

class AuthService {
  // Método para iniciar sesión
  login(email, password) {
    return axios
      .post(API_URL + 'login', {
        correo: email,
        password: password
      })
      .then(response => {
        if (response.data.token) {
          // Almacenar el token JWT en el almacenamiento local del navegador
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  // Método para cerrar sesión
  logout() {
    // Eliminar el token y otros datos del usuario del almacenamiento local
    localStorage.removeItem('user');
  }

  // Método para obtener los datos del usuario almacenados en el local storage
  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

export default new AuthService();
